import { render, staticRenderFns } from "./Controles.vue?vue&type=template&id=0fe46212"
import script from "./Controles.vue?vue&type=script&lang=js"
export * from "./Controles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports